export const APP_UPDATE_SCROLL_TOP = 'concrete/APP_UPDATE_SCROLL_TOP'
export const APP_UPDATE_VIEWPORT_DIMENSIONS = 'concrete/APP_UPDATE_VIEWPORT_DIMENSIONS'
export const APP_UPDATE_DOCUMENT_HEIGHT = 'concrete/APP_UPDATE_DOCUMENT_HEIGHT'
export const APP_START_COLLECTION_EXIT_OVERLAY = 'concrete/APP_START_COLLECTION_EXIT_OVERLAY'
export const APP_COMPLETE_COLLECTION_EXIT_OVERLAY = 'concrete/APP_COMPLETE_COLLECTION_EXIT_OVERLAY'
export const APP_TOGGLE_VIEW_MODE = 'concrete/APP_TOGGLE_VIEW_MODE'
export const APP_UPDATE_ROW_DELTA = 'concrete/APP_UPDATE_ROW_DELTA' 
export const APP_UPDATE_ROW_OFFSET = 'concrete/APP_UPDATE_ROW_OFFSET' 
export const APP_TOGGLE_DEBUG = 'concrete/APP_TOGGLE_DEBUG'
export const APP_CURRENT_PAGE = 'concrete/APP_CURRENT_PAGE'
export const APP_SET_TRANSITION_ACTIVE = 'concrete/APP_SET_TRANSITION_ACTIVE'
export const APP_SET_PREVENT_SCROLL = 'concrete/APP_PREVENT_SCROLL'
export const APP_SET_GRID_ANIMATE = 'concrete/APP_SET_GRID_ANIMATE'
export const APP_CHANGE_LOCATION = 'concrete/APP_CHANGE_LOCATION'




// WEBPACK FOOTER //
// ./src/components/app/action-types.js